import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

export const getOperationalUnitList = createAsyncThunk(
  "operationalUnit/getAll",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        "/api/rkg/gospodarstvo/page",
        null,
        page,
        filter,
        sort
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const getOperationalUnitById = createAsyncThunk(
  "operationalUnit/getById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(`/api/rkg/gospodarstvo/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const createOperationalUnit = createAsyncThunk(
  "operationalUnit/create",
  async (dto, { rejectWithValue }) => {
    try {
      const response = await ApiClient.post("/api/rkg/gospodarstvo", dto);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const updateOperationalUnit = createAsyncThunk(
  "operationalUnit/update",
  async ({ id, dto }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.put(`/api/rkg/gospodarstvo/${id}`, dto);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const deleteOperationalUnit = createAsyncThunk(
  "operationalUnit/delete",
  async ({ id, version }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.delete(
        `/api/rkg/gospodarstvo/${id}?version=${version}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const getOperationalUnitPage = createAsyncThunk(
  "operationalUnit/getPage",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        "/api/rkg/gospodarstvo/page",
        null,
        page,
        filter,
        sort
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const operationalUnitSlice = createSlice({
  name: "operationalUnit",
  initialState: {
    current: null,
    page: {},
    error: null,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Get all
      .addCase(getOperationalUnitList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload?.content || [];
        state.page = action.payload;
      })
      .addCase(getOperationalUnitList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getOperationalUnitList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      // Get by id
      .addCase(getOperationalUnitById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.current = action.payload;
      })
      .addCase(getOperationalUnitById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getOperationalUnitById.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      // Create
      .addCase(createOperationalUnit.fulfilled, (state, action) => {
        state.isLoading = false;
        state.current = action.payload.output; // payload.output = dto
      })
      .addCase(createOperationalUnit.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createOperationalUnit.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      // Update
      .addCase(updateOperationalUnit.fulfilled, (state, action) => {
        state.isLoading = false;
        state.current = action.payload; // payload = dto
      })
      .addCase(updateOperationalUnit.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(updateOperationalUnit.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      // Delete
      .addCase(deleteOperationalUnit.fulfilled, (state, action) => {
        state.isLoading = false;
        state.current = action.payload;
      })
      .addCase(deleteOperationalUnit.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteOperationalUnit.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      // Get page
      .addCase(getOperationalUnitPage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
      })
      .addCase(getOperationalUnitPage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getOperationalUnitPage.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      });
  },
});

export default operationalUnitSlice.reducer;
